import Tag from "common/Tags/Tag";
import { useTheme } from "styled-components";
import styled from "styled-components";
import Text from "common/Typography/Text";
import Flex from "common/Boxes/Flex";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

interface LastMonthChangeProps {
  lastMonthChange: number | string;
}

const LastMonthChange = ({ lastMonthChange }: LastMonthChangeProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);
  const appTheme = useTheme();
  const lastMonthChangeText = `+${lastMonthChange}`;

  const numberChange =
    typeof lastMonthChange === "string"
      ? Number(lastMonthChange.slice(1))
      : lastMonthChange;

  const lastMonthChangeTag =
    numberChange > 0 ? (
      <Tag color={appTheme.colors.green} style={{ lineHeight: "10px" }}>
        {lastMonthChangeText}
      </Tag>
    ) : (
      <StyledText>{lastMonthChangeText}</StyledText>
    );

  return (
    <Flex>
      <div style={{ marginRight: 4 }}>{lastMonthChangeTag}</div>
      <StyledText> {t("common.from_last_month")}</StyledText>
    </Flex>
  );
};

export default LastMonthChange;

const StyledText = styled(Text).attrs({ type: "secondary" })`
  font-size: 11px;
  display: flex;
  align-items: baseline;
  margin-top: 4px;
`;
